module.exports = __webpack_public_path__ + "img/sidebar-image.a5e56956.png";